import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const inclusions = ['Guía Maestra del Método', 'Matriz de Cantidades Semanales', 'Sistema de los 3 Frascos paso a paso', 'La Cascada del Sueño de 15 minutos', 'Protocolo de Crisis para noches difíciles'];
  return <section id="oferta" className="py-24 px-4 bg-cream relative" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <div className="text-center mb-12" data-id="element-144">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-warm-900 mb-4 font-heading" data-id="element-145">
            Recupera tus noches
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-warm-800/80" data-id="element-146">
            Obtén el Método Completo Digital
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} id="oferta-card" className="bg-white rounded-[2rem] shadow-xl shadow-warm-900/5 border border-warm-100 overflow-hidden max-w-2xl mx-auto relative" data-id="element-147">
          {/* Decorative top bar */}
          <div className="h-2 w-full bg-gold" data-id="element-148" />

          <div className="p-8 md:p-12" data-id="element-149">
            <div className="space-y-4 mb-10" data-id="element-150">
              <p className="font-semibold text-warm-900 mb-6 text-lg" data-id="element-151">
                Incluye acceso inmediato a:
              </p>
              {inclusions.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4 + index * 0.1
            }} className="flex items-start gap-3" data-id="element-152">
                  <div className="mt-1 bg-gold/20 rounded-full p-1 text-gold-dark shrink-0" data-id="element-153">
                    <CheckIcon className="w-4 h-4" strokeWidth={3} data-id="element-154" />
                  </div>
                  <span className="text-warm-800 text-lg" data-id="element-155">{item}</span>
                </motion.div>)}
            </div>

            <div className="text-center pt-6 border-t border-warm-100" data-id="element-156">
              <motion.a href="https://vidaconmetodo.com/cart/44482692808819:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full bg-gold text-warm-900 font-bold py-5 px-8 rounded-2xl text-lg md:text-xl shadow-[0_8px_20px_rgba(212,168,83,0.3)] hover:shadow-[0_12px_25px_rgba(212,168,83,0.4)] transition-all duration-300 mb-4" data-id="element-157">
                QUIERO RECUPERAR MIS NOCHES
              </motion.a>
              <div className="mt-6 mb-4" data-id="element-158">
                <div className="inline-block bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full mb-3 tracking-wide" data-id="element-159">
                  68% OFF
                </div>
                <div className="flex items-baseline justify-center gap-3" data-id="element-160">
                  <span className="text-2xl text-warm-800/40 font-heading line-through" data-id="element-161">
                    $19.99
                  </span>
                  <span className="text-5xl font-bold text-warm-900 font-heading tracking-tight" data-id="element-162">
                    $6.39
                  </span>
                  <span className="text-xl text-warm-800/60 font-medium" data-id="element-163">
                    USD
                  </span>
                </div>
              </div>
              <p className="text-warm-800/60 text-sm font-medium flex items-center justify-center gap-2" data-id="element-164">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-165" />
                Acceso instantáneo.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}